import { defineMessage } from 'services/localization';

export const messages = {
    createInApprovalMax: defineMessage('create_in_approvalmax'),
    description: defineMessage('add_users_who_are_autho_approval_in_approvalmax'),
    descriptionEmpty: defineMessage('add_at_least_one_user_w_approval_in_approvalmax'),
    addRequester: defineMessage('add_a_requester'),
    selectRequester: defineMessage('select_a_requester'),
    openMatrixTitle: defineMessage('define_the_requester_ri_in_the_requester_matrix'),
};
